import { Button, Card, Form, Input, message, Layout, Space, Spin, Popconfirm } from "antd";
import { db, auth, storage, functions } from "./base";
import { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy, deleteDoc, doc } from "firebase/firestore";
import { ref, uploadByts, listAll, getDownloadURL } from "firebase/storage";
import NavBar from "./components/NavBar";
import { getFunctions, httpsCallable } from "firebase/functions";
import {useNavigate} from "react-router-dom";

const onFinishFailed = (errorInfo) => {
  console.log("Failed:", errorInfo);
};

const AllNotificationPage = () => {
  const [loading, setLoading] = useState(true);
  const [notifiche, setNotifiche] = useState([]);
  const [deletingId, setDeletingId] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const notificheArray = [];
    const q = query(collection(db, "notifiche"), orderBy("creazione", "desc"));
    getDocs(q).then((querySnapshot) => {
      querySnapshot.forEach((docSnapshot) => {
        console.log(docSnapshot.data());
        notificheArray.push({ ...docSnapshot.data(), id: docSnapshot.id });
      });
      setNotifiche(notificheArray);
      setLoading(false);
    });
  }, []);

  const handleDelete = async (notificaId) => {
    try {
      setDeletingId(notificaId);
      await deleteDoc(doc(db, "notifiche", notificaId));
      setNotifiche(notifiche.filter(n => n.id !== notificaId));
      message.success("Notifica eliminata con successo");
    } catch (error) {
      console.error("Errore durante l'eliminazione:", error);
      message.error("Errore durante l'eliminazione della notifica");
    } finally {
      setDeletingId(null);
    }
  };

  if (loading)
    return (
      <div>
        <Spin />
      </div>
    );

  const { Meta } = Card;

  return (
    <>
      <NavBar />
      <main>
        <Button onClick={()=>navigate('/crea-notifica')} type={"primary"} size={'large'}>Crea nuova notifica</Button>
        <h1>Tutte le Notifiche</h1>
        {notifiche.map((item, idx) => (
          <Card
            key={item.title + idx}
            hoverable
            style={{ width: "100%", marginBottom: 20 }}
            cover={
              item.immagine && (
                <img
                  alt="example"
                  heigth={200}
                  style={{
                    maxHeight: 300,
                    objectFit: "cover",
                    backgroundColor: "black",
                  }}
                  src={item.immagine}
                />
              )
            }
          >
            <Meta title={item.titolo} />
            <p style={{ marginTop: 5 }}>{item.testo}</p>
            <p style={{color: 'blue'}}>
              {item.programmato_per && 'programmato per: ' + new Date(item.programmato_per.seconds * 1000).toLocaleString('it-IT', {hour: '2-digit', minute: '2-digit', day: '2-digit', month: '2-digit', year: 'numeric'})}
            </p>
            <p style={{ marginTop: 5, color: "grey" }}>
              creato: {new Date(item.creazione.seconds * 1000).toLocaleString('it-IT', {hour: '2-digit', minute: '2-digit', day: '2-digit', month: '2-digit', year: 'numeric'})}
            </p>
            <Popconfirm
              title="Sei sicuro di voler eliminare questa notifica?"
              onConfirm={() => handleDelete(item.id)}
              okText="Sì"
              cancelText="No"
            >
              <Button
                danger
                type="primary"
                style={{ marginTop: 10 }}
                loading={deletingId === item.id}
              >
                Elimina
              </Button>
            </Popconfirm>
          </Card>
        ))}
      </main>
    </>
  );
};
export default AllNotificationPage;
